import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { specSchema } from '@eluve/sdui-types';

const c = initContract();

export const extensionOnboardingPermissionTypes = [
  'microphone',
  'site-access',
] as const;

export type ExtensionOnboardingPermissionType =
  (typeof extensionOnboardingPermissionTypes)[number];

export const extensionOnboardingContract = c.router(
  {
    getPermissionSpec: {
      method: 'GET',
      path: '/spec',
      query: z.object({
        type: z.enum(extensionOnboardingPermissionTypes),
        domains: z.string().optional(),
        vendors: z.string().optional(),
      }),
      responses: {
        200: z.object({
          spec: specSchema,
        }),
        400: z.object({
          message: z.string(),
        }),
      },
    },
  },
  { pathPrefix: '/extension-onboarding' },
);
